import { DashMessage } from "./DashMessage"
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";

export const UnpublishedMessage = () => {

    const { switchMode } = useDashboardDomainContext();

    return (
        <DashMessage
            icon={"protractor"}
            title={"Dashboard in Progress"}
            description={"This dashboard has draft structure changes that are not published yet."}
            buttonText={"Continue Editing"}
            onClick={() => switchMode("design")}
        />
    )
}
